const facilitySearchBoxResources = {
    noOptionsText: 'No results'
};
export default facilitySearchBoxResources;
